export const translations = {
  fr: {
    nav: {
      story: "Notre histoire",
      activities: "Activités",
      summer: "Kids Camp",
      workshops: "Ateliers",
      events: "Événements",
      carnet: "Carnet",
      member: "Devenir adhérent",
      book: "Réserver",
    },
    hero: {
      kicker: "Association locale · Année scolaire 2026–2027",
      title: "Une année d'aventures\nà Saint-Barth",
      subtitle:
        "Island Camps accompagne les enfants tout au long de l'année scolaire 2026–2027 : ateliers du mercredi et du samedi, Kids Camps pendant les vacances scolaires et activités créatives, au cœur de Saint-Barthélemy.",
      cta: "Découvrir le Kids Camp",
      ctaSecondary: "Devenir adhérent",
    },
    story: {
      kicker: "Notre histoire",
      title: "Une aventure née depuis 2012, 14 ans auprès des enfants de Saint-Barth",
      p1: "Depuis 2012, soit 14 ans d'expérience, My Little Circle accompagne les familles de Saint-Barth à travers des services de garde d'enfants, d'animations, d'ateliers créatifs et d'événements sur mesure.",
      p2: "Au fil des années, une évidence s'est imposée : créer un lieu où les enfants de l'île pourraient vivre des expériences enrichissantes, développer leur autonomie, leur créativité et leur curiosité tout en s'amusant. C'est ainsi qu'est né Island Camps.",
      p3: "Aujourd'hui, l'association a pour mission de proposer aux familles locales des solutions de garde de qualité pendant les vacances scolaires et, prochainement, durant les temps périscolaires.",
      stats: [
        { value: "14", label: "années d'expérience (depuis 2012)" },
        { value: "6", label: "enfants max par groupe" },
        { value: "100%", label: "local & familial" },
      ],
    },
    vision: {
      kicker: "Notre vision",
      title: "Plus qu'une garde, une expérience éducative",
      text: "Chez Island Camps, nous croyons que chaque activité est une occasion d'apprendre, de créer, d'explorer et de grandir. Chaque enfant est encouragé à expérimenter, imaginer, construire et participer à des projets collectifs qui donnent du sens à ses apprentissages.",
      pillars: [
        "La confiance en soi",
        "La créativité",
        "L'autonomie",
        "La coopération",
        "La découverte de la nature",
        "L'ouverture sur la culture caribéenne",
      ],
    },
    activities: {
      kicker: "Nos activités",
      title: "Des journées pensées comme des aventures",
      items: [
        { title: "Vacances scolaires", text: "Des journées d'aventure, de création et de découverte dans un environnement naturel exceptionnel.", badge: null },
        { title: "Périscolaire", text: "Des activités éducatives et ludiques adaptées au rythme des enfants après l'école.", badge: "Bientôt disponible" },
        { title: "Ateliers créatifs", text: "Arts, artisanat, création et projets inspirés de la culture locale.", badge: null },
        { title: "Nature & Exploration", text: "Découverte de l'environnement de Saint-Barth et sensibilisation à la nature.", badge: null },
      ],
    },
    membership: {
      kicker: "Devenir adhérent",
      title: "Rejoignez l'aventure Island Camps",
      text: "L'adhésion annuelle permet d'accéder aux réservations des activités proposées par l'association.",
      includesTitle: "L'adhésion comprend :",
      includes: [
        "L'accès aux inscriptions",
        "Les réservations prioritaires",
        "Les tarifs adhérents",
        "L'assurance des enfants lors des activités",
        "Les informations exclusives de l'association",
      ],
      priceLabel: "Tarif adhésion",
      pricePer: "par an",
      cta: "Devenir adhérent",
    },
    summer: {
      kicker: "Kids Camp · Été 2026",
      title: "Le Kids Camp du lagon de Grand Cul-de-Sac",
      text: "Cet été, les enfants embarquent dans une aventure unique au bord du lagon. Entre créativité, jeux, nature, découvertes et projets collectifs, chaque semaine est pensée comme une véritable exploration.",
      cta: "Découvrir le programme de l'été",
    },
    testimonials: {
      kicker: "Témoignages",
      title: "La confiance des familles de l'île",
      items: [
        { quote: "Une équipe d'une bienveillance incroyable. Ma fille rentre chaque soir des étoiles plein les yeux, en sécurité et épanouie.", author: "Camille", role: "maman de Lou, 6 ans" },
        { quote: "Du vrai professionnalisme : encadrement attentif, activités variées et un cadre naturel magnifique. On recommande les yeux fermés.", author: "Thomas & Sarah", role: "parents de Noé, 8 ans" },
        { quote: "Mes enfants ne veulent plus partir ! Ils créent, explorent, se font des amis. Exactement ce qu'on cherchait à Saint-Barth.", author: "Élodie", role: "maman de 2 enfants" },
      ],
    },
    news: {
      kicker: "Actualités",
      title: "Les dernières nouvelles de l'association",
      items: [
        { tag: "Inscriptions", date: "Juin 2026", title: "Ouverture des inscriptions Été 2026", text: "Les réservations du Kids Camp du lagon sont ouvertes aux adhérents. Places limitées à 6 enfants par session." },
        { tag: "Nouveauté", date: "Septembre 2026", title: "Lancement du périscolaire", text: "Bientôt, des activités éducatives et ludiques après l'école, adaptées au rythme des enfants." },
        { tag: "Événement", date: "Été 2026", title: "Nouvelles sessions thématiques", text: "Pirates, sirènes, petits explorateurs : chaque semaine, un univers d'aventure différent." },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Parlons de l'aventure de votre enfant",
      text: "Une question, une envie de rejoindre l'association ? Nous sommes là pour vous accompagner.",
      instagram: "Instagram",
      email: "E-mail",
      phone: "Téléphone",
    },
    footer: {
      tagline: "Pour les enfants. Pour les familles. Pour l'île.",
      assoc: "Association Island Camps",
      location: "Saint-Barthélemy",
      contact: "Contact",
      rights: "Tous droits réservés.",
    },
    whyChoose: {
      kicker: "Pourquoi Island Camps",
      title: "Une association pensée pour rassurer les parents",
      badge: "Accueil Collectif de Mineurs déclaré auprès de la DRAJES (Jeunesse & Sports)",
      items: [
        { title: "Sécurité déclarée", text: "Structure officiellement déclarée ACM. Encadrement qualifié et assurance des enfants incluse." },
        { title: "14 ans d'expérience", text: "Née de My Little Circle (depuis 2012), référence de la garde d'enfants premium à Saint-Barth." },
        { title: "Petits groupes", text: "6 enfants maximum par session pour une attention réelle à chacun." },
        { title: "Nature & créativité", text: "Des journées dehors, au bord du lagon, entre exploration et projets créatifs." },
      ],
    },
    philosophy: {
      kicker: "Notre pédagogie",
      title: "Apprendre en explorant, grandir en créant",
      text: "Une approche inspirée de la nature et du jeu, où chaque enfant avance à son rythme.",
      steps: [
        { title: "Explorer", text: "Découvrir la nature de Saint-Barth, le lagon et le vivant." },
        { title: "Créer", text: "Arts, artisanat et projets inspirés de la culture caribéenne." },
        { title: "Coopérer", text: "Des projets collectifs qui donnent du sens aux apprentissages." },
        { title: "Grandir", text: "Confiance en soi, autonomie et curiosité, tout en s'amusant." },
      ],
    },
    afterschool: {
      kicker: "Bientôt",
      badge: "Bientôt disponible",
      title: "Le périscolaire arrive",
      text: "Après l'école, des activités éducatives et ludiques adaptées au rythme des enfants. Ouverture prochaine — devenez adhérent pour être informé en priorité.",
    },
    faq: {
      kicker: "FAQ",
      title: "Vos questions, nos réponses",
      items: [
        { q: "À partir de quel âge ?", a: "Le Kids Camp accueille les enfants de 6 à 14 ans, répartis par tranches d'âge adaptées." },
        { q: "Faut-il être adhérent pour réserver ?", a: "Oui. L'adhésion annuelle (75€) donne accès aux réservations et au tarif membre." },
        { q: "Le déjeuner est-il fourni ?", a: "Non, le déjeuner n'est pas fourni. Prévoyez un pique-nique et une gourde." },
        { q: "Où se déroule le camp ?", a: "Au bord du lagon de Grand Cul-de-Sac, un cadre naturel exceptionnel et sécurisé." },
        { q: "Puis-je inscrire plusieurs enfants ?", a: "Oui, inscrivez plusieurs enfants et choisissez leurs créneaux individuellement." },
        { q: "Les enfants sont-ils assurés ?", a: "Oui, l'assurance des enfants pendant les activités est incluse dans l'adhésion." },
      ],
    },
    pricing: {
      kicker: "Tarifs",
      title: "Des tarifs pensés pour les familles",
      nonMember: "Non-membre",
      member: "Membre",
      memberVolume: "Membre · 10 sessions et +",
      perSession: "/ session",
      badgePopular: "Le plus choisi",
      note: "L'adhésion annuelle (75€) débloque le tarif membre. Déjeuner non fourni.",
      cta: "Devenir adhérent",
    },
    kidscamp: {
      hero: {
        kicker: "Kids Camp · Été 2026",
        title: "Un été d'aventures au bord du lagon",
        subtitle: "Six semaines d'exploration, de création et de jeux au cœur du lagon de Grand Cul-de-Sac. Chaque journée est une nouvelle expédition.",
        cta: "Réserver une session",
      },
      concept: {
        title: "Bien plus qu'un centre de loisirs",
        text: "À Island Camps, chaque activité est une occasion d'apprendre, de créer et de grandir. En petits groupes de 6 enfants, nos animateurs éveillent la curiosité, la confiance et l'imaginaire de chaque enfant, dans un cadre naturel d'exception.",
      },
      notebook: {
        kicker: "Le fil rouge de l'été",
        title: "Le Carnet de l'Explorateur",
        text: "Chaque enfant reçoit son carnet d'explorateur : missions, défis nature, croquis, trésors récoltés et souvenirs de la semaine. Un fil conducteur ludique qui donne du sens à chaque journée.",
      },
      themes: {
        title: "Six semaines, six thèmes",
        items: [
          { week: "Semaine 1", emoji: "🧭", name: "Qui suis-je ?", desc: "Découverte de soi, prénoms, portraits et premières amitiés." },
          { week: "Semaine 2", emoji: "💛", name: "Les émotions", desc: "Reconnaître, exprimer et apprivoiser ses émotions par le jeu." },
          { week: "Semaine 3", emoji: "🌱", name: "Le vivant", desc: "Nature, plantes, animaux et respect du vivant qui nous entoure." },
          { week: "Semaine 4", emoji: "✨", name: "L'imaginaire", desc: "Contes, mondes inventés et création débridée." },
          { week: "Semaine 5", emoji: "🤝", name: "Les liens", desc: "Coopération, entraide et grands projets d'équipe." },
          { week: "Semaine 6", emoji: "♻️", name: "Transformer", desc: "Récup', arts et matières à métamorphoser." },
        ],
      },
      schedule: {
        title: "Une journée type",
        items: [
          { time: "8h30 – 9h30", label: "Accueil & rituel du matin" },
          { time: "9h30 – 10h30", label: "Grande activité : exploration & jeu" },
          { time: "10h30", label: "Collation & temps calme" },
          { time: "11h00", label: "Atelier créatif" },
          { time: "12h00", label: "Récupération (demi-journée) ou pique-nique / lunch time" },
          { time: "13h00 – 14h00", label: "Accueil & rituel de l'après-midi" },
          { time: "14h00", label: "Reprise des activités & jeux" },
          { time: "16h00", label: "Goûter" },
          { time: "16h30 – 17h00", label: "Récupération des enfants" },
        ],
      },
      ages: {
        title: "Groupes d'âge",
        items: [
          { range: "6–8 ans", label: "Les Explorateurs" },
          { range: "9–11 ans", label: "Les Grands Aventuriers" },
          { range: "12–14 ans", label: "Les Pionniers" },
        ],
      },
      options: {
        title: "Demi-journée ou journée complète",
        text: "Composez le planning qui vous convient : matin, après-midi, ou journée complète.",
        morning: "Matin · 8h30–12h30",
        afternoon: "Après-midi · 13h00–17h00",
        fullday: "Journée complète · 8h30–17h00",
      },
      location: {
        title: "Au bord du lagon de Grand Cul-de-Sac",
        text: "Un cadre naturel protégé, idéal pour les activités nautiques douces, l'exploration et les jeux en plein air, en toute sécurité.",
      },
      bring: {
        title: "À prévoir",
        items: ["Pique-nique & gourde", "Crème solaire & chapeau", "Maillot & serviette", "Change complet"],
      },
      safety: {
        title: "Sécurité & encadrement",
        items: ["Structure déclarée ACM (DRAJES)", "Encadrants qualifiés", "6 enfants max par session", "Assurance incluse pour les adhérents"],
      },
      gallery: { title: "L'ambiance en images" },
    },
    workshops: {
      hero: {
        kicker: "Ateliers",
        title: "Les ateliers du mercredi & samedi",
        subtitle: "Des ateliers créatifs et nature en petit comité, pour explorer, fabriquer et s'émerveiller tout au long de l'année.",
      },
      age: "Âge",
      duration: "Durée",
      spots: "Places",
      book: "Réserver",
      soon: "Bientôt",
      regTitle: "Réservez vos ateliers",
      regSubtitle: "Choisissez vos séances du mercredi & samedi après-midi. Tarif identique aux sessions : 50 € (non-adhérent) · 45 € (adhérent) · 40 € (dès 10 séances).",
      specialTitle: "Événements spéciaux",
      specialSubtitle: "Nos ateliers thématiques et événements ponctuels.",
    },
    booking: {
      title: "Réservez vos sessions",
      subtitle: "Année scolaire 2026–2027 · Matin & Après-midi · 6 enfants max par session",
      parent: "Vos coordonnées",
      parentName: "Nom du parent",
      email: "E-mail",
      phone: "Téléphone",
      children: "Enfants",
      childName: "Prénom de l'enfant",
      addChild: "Ajouter un enfant",
      selectFor: "Planning de",
      morning: "Matin",
      afternoon: "Après-midi",
      full: "Complet",
      remaining: "places",
      summary: "Récapitulatif",
      totalSessions: "Sessions sélectionnées",
      unitPrice: "Prix unitaire",
      discountActive: "Tarif pack appliqué (≥ 10 sessions pour un enfant) 🎉",
      discountHint: "10 sessions pour un même enfant → 40€ / session pour cet enfant.",
      lunch: "Déjeuner non fourni — pensez au pique-nique 🥪",
      total: "Total",
      pay: "Payer par carte",
      paying: "Redirection vers le paiement…",
      emptyCart: "Sélectionnez au moins une session pour continuer.",
      months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      days: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
      weekend: "Week-end fermé",
      success: "Paiement confirmé !",
      successText: "Merci, votre réservation est confirmée. Un récapitulatif vous attend ci-dessous.",
      processing: "Vérification du paiement…",
      failed: "Le paiement n'a pas abouti. Vous pouvez réessayer.",
      paymentPending: "Paiement en cours de traitement",
      paymentPendingText: "Votre paiement est en cours de traitement. Vous recevrez un e-mail de confirmation. Vous pouvez aussi vérifier dans votre espace compte.",
      viewMyAccount: "Voir mon compte",
      backToBooking: "Nouvelle réservation",
      memberBadge: "Adhérent · tarif membre",
      notMemberBadge: "Non-membre · tarif standard",
      memberNudge: "Devenez adhérent (75€/an) pour le tarif membre dès 45€/session.",
      becomeMember: "Devenir adhérent",
      fullDay: "Journée",
      checking: "Vérification…",
      emergencyTitle: "Contact d'urgence",
      emergencyName: "Nom du contact d'urgence",
      emergencyPhone: "Téléphone d'urgence",
      allergies: "Allergies / infos médicales",
      allergiesPlaceholder: "Ex : arachides, asthme… (optionnel)",
      requiredFields: "Merci de renseigner votre nom et un e-mail valide.",
      payError: "Une erreur est survenue lors du paiement. Réessayez.",
      childFirstName: "Prénom de l'enfant",
      childLastName: "Nom de l'enfant",
      dob: "Date de naissance",
      groupHint: "Groupe (indicatif selon l'âge)",
      groupUnknown: "Renseignez la date de naissance",
      outOfRange: "Hors tranche 3–14 ans",
      yearsShort: "ans",
      noDates: "Aucune date disponible pour cette période pour le moment.",
      ageGroups: [
        { min: 3, max: 5, name: "Les Petits Mousses" },
        { min: 6, max: 8, name: "Les Explorateurs" },
        { min: 9, max: 11, name: "Les Grands Aventuriers" },
        { min: 12, max: 14, name: "Les Pionniers" },
      ],
      consentsTitle: "Autorisations",
      consentsIntro: "Merci d'indiquer les autorisations pour votre/vos enfant(s) (facultatif).",
      authorizedPickup: "Personnes autorisées à récupérer l'enfant",
      authorizedPickupPlaceholder: "Nom(s) et lien de parenté (optionnel)",
      consentImage: "J'autorise la prise et la diffusion de photos/vidéos (droit à l'image).",
      consentOutdoor: "J'autorise la participation aux activités et sorties en extérieur.",
      consentSwim: "J'autorise mon enfant à se baigner sous surveillance.",
      consentTransport: "J'autorise le transport / la conduite de mon enfant en cas d'urgence (véhicule / secours).",
      consentRules: "Je reconnais avoir pris connaissance et accepter le règlement intérieur de l'association.",
      residentConfirm: "Je confirme que l'enfant réside à Saint-Barthélemy.",
      residentRequired: "Les activités sont réservées aux enfants résidant à Saint-Barthélemy. Merci de cocher la confirmation.",
      comingSoon: "Ouverture prochaine",
      underAgeNotice: "Les inscriptions sont réservées aux enfants ayant 6 ans révolus le jour de la session. Ouverture prochaine pour les plus jeunes.",
      underAgeError: "Certaines sessions sélectionnées concernent un enfant de moins de 6 ans. Merci de les retirer pour continuer.",
      consentYes: "Oui",
      consentNo: "Non",
      rulesRequired: "Merci d'accepter le règlement intérieur pour continuer.",
    },
    carnet: {
      kicker: "Le carnet",
      title: "Le carnet de bord de l'été",
      text: "Quelques instants volés de nos aventures : pirates en herbe, sirènes, petites enquêtes et trésors de la nature.",
      cta: "Réserver votre place",
    },
    member: {
      title: "Devenir adhérent",
      subtitle: "Adhésion annuelle à l'association Island Camps — 75 € / an (50 € adhésion + 25 € assurance tous risques enfant)",
      info: "Vos informations",
      name: "Nom complet",
      email: "E-mail",
      phone: "Téléphone",
      summary: "Récapitulatif",
      item: "Adhésion annuelle",
      total: "Total",
      pay: "Adhérer · Payer 75 €",
      feeMembership: "Adhésion",
      feeInsurance: "Assurance tous risques (enfant)",
      paying: "Redirection vers le paiement…",
      includesTitle: "Inclus dans l'adhésion",
      success: "Bienvenue chez Island Camps !",
      successText: "Votre adhésion est confirmée. Vous pouvez désormais réserver les activités de l'association.",
      processing: "Vérification du paiement…",
      failed: "Le paiement n'a pas abouti. Vous pouvez réessayer.",
      paymentPending: "Paiement en cours de traitement",
      paymentPendingText: "Votre paiement est en cours de traitement. Vous recevrez un e-mail de confirmation. Vous pouvez aussi vérifier dans votre espace compte.",
      viewMyAccount: "Voir mon compte",
      goBook: "Réserver une session",
      requiredFields: "Merci de renseigner votre nom et un e-mail valide.",
      payError: "Une erreur est survenue lors du paiement. Réessayez.",
      address: "Adresse",
      childrenTitle: "Enfant(s)",
      addChild: "Ajouter un enfant",
      childFirstName: "Prénom de l'enfant",
      childLastName: "Nom de l'enfant",
      dob: "Date de naissance",
      groupHint: "Groupe (indicatif selon l'âge)",
      groupUnknown: "Renseignez la date de naissance",
      yearsShort: "ans",
      outOfRange: "Hors tranche 6–14 ans",
      medical: "Informations médicales",
      medicalPlaceholder: "Allergies, traitements en cours, médecin traitant…",
      interests: "Ce qu'il/elle aime dans la vie",
      interestsPlaceholder: "Ses passions, activités préférées…",
      emergencyTitle: "Contact d'urgence",
      emergencyName: "Nom du contact d'urgence",
      emergencyPhone: "Téléphone d'urgence",
      consentsTitle: "Autorisations",
      consentsIntro: "Autorisations pour votre/vos enfant(s) (facultatif).",
      consentImage: "J'autorise la prise et la publication de photos/vidéos (droit à l'image).",
      consentOutdoor: "J'autorise la participation aux activités et sorties en extérieur.",
      consentSwim: "J'autorise mon enfant à se baigner sous surveillance.",
      consentTransport: "J'autorise le transport / la conduite de mon enfant en cas d'urgence (véhicule / secours).",
      consentRules: "Je reconnais avoir pris connaissance et accepter le règlement intérieur.",
      consentsRequired: "Merci d'accepter tous les consentements obligatoires pour continuer.",
    },
  },

  en: {
    nav: {
      story: "Our story",
      activities: "Activities",
      summer: "Kids Camp",
      workshops: "Workshops",
      events: "Events",
      carnet: "Logbook",
      member: "Become a member",
      book: "Book now",
    },
    hero: {
      kicker: "Local association · School year 2026–2027",
      title: "A year of adventures\nin Saint-Barth",
      subtitle:
        "Island Camps supports children throughout the 2026–2027 school year: Wednesday and Saturday workshops, holiday Kids Camps and creative activities, at the heart of Saint-Barthélemy.",
      cta: "Discover the Kids Camp",
      ctaSecondary: "Become a member",
    },
    story: {
      kicker: "Our story",
      title: "An adventure born since 2012 — 14 years with the children of Saint-Barth",
      p1: "Since 2012 — 14 years of experience — My Little Circle has supported Saint-Barth families through childcare, activities, creative workshops and bespoke events.",
      p2: "Over the years, one thing became clear: create a place where the island's children could live enriching experiences, build their independence, creativity and curiosity while having fun. That's how Island Camps was born.",
      p3: "Today, the association's mission is to offer local families quality childcare during school holidays and, soon, during after-school hours.",
      stats: [
        { value: "14", label: "years of experience (since 2012)" },
        { value: "6", label: "kids max per group" },
        { value: "100%", label: "local & family-run" },
      ],
    },
    vision: {
      kicker: "Our vision",
      title: "More than childcare — an educational experience",
      text: "At Island Camps, we believe every activity is a chance to learn, create, explore and grow. Each child is encouraged to experiment, imagine, build and take part in collective projects that give meaning to their learning.",
      pillars: [
        "Self-confidence",
        "Creativity",
        "Independence",
        "Cooperation",
        "Discovering nature",
        "Openness to Caribbean culture",
      ],
    },
    activities: {
      kicker: "Our activities",
      title: "Days designed as adventures",
      items: [
        { title: "School holidays", text: "Days of adventure, creation and discovery in an exceptional natural environment.", badge: null },
        { title: "After-school", text: "Educational and fun activities tailored to children's rhythm after school.", badge: "Coming soon" },
        { title: "Creative workshops", text: "Arts, crafts, creation and projects inspired by local culture.", badge: null },
        { title: "Nature & Exploration", text: "Discovering Saint-Barth's environment and raising awareness of nature.", badge: null },
      ],
    },
    membership: {
      kicker: "Become a member",
      title: "Join the Island Camps adventure",
      text: "Annual membership gives access to bookings for the activities offered by the association.",
      includesTitle: "Membership includes:",
      includes: [
        "Access to sign-ups",
        "Priority bookings",
        "Member rates",
        "Children's insurance during activities",
        "Exclusive association updates",
      ],
      priceLabel: "Membership fee",
      pricePer: "per year",
      cta: "Become a member",
    },
    summer: {
      kicker: "Kids Camp · Summer 2026",
      title: "The Grand Cul-de-Sac lagoon Kids Camp",
      text: "This summer, children embark on a unique adventure by the lagoon. Between creativity, games, nature, discoveries and collective projects, each week is designed as a true exploration.",
      cta: "Discover the summer programme",
    },
    testimonials: {
      kicker: "Testimonials",
      title: "Trusted by the island's families",
      items: [
        { quote: "An incredibly caring team. My daughter comes home every evening with stars in her eyes — safe and thriving.", author: "Camille", role: "mum of Lou, 6" },
        { quote: "True professionalism: attentive supervision, varied activities and a beautiful natural setting. We highly recommend.", author: "Thomas & Sarah", role: "parents of Noé, 8" },
        { quote: "My kids never want to leave! They create, explore, make friends. Exactly what we were looking for in Saint-Barth.", author: "Élodie", role: "mum of 2" },
      ],
    },
    news: {
      kicker: "News",
      title: "Latest news from the association",
      items: [
        { tag: "Sign-ups", date: "June 2026", title: "Summer 2026 sign-ups now open", text: "Lagoon Kids Camp bookings are open to members. Limited to 6 children per session." },
        { tag: "New", date: "September 2026", title: "After-school programme launch", text: "Soon, fun and educational activities after school, tailored to children's rhythm." },
        { tag: "Event", date: "Summer 2026", title: "New themed sessions", text: "Pirates, mermaids, little explorers: each week, a different world of adventure." },
      ],
    },
    contact: {
      kicker: "Contact",
      title: "Let's talk about your child's adventure",
      text: "A question, or want to join the association? We're here to help.",
      instagram: "Instagram",
      email: "Email",
      phone: "Phone",
    },
    footer: {
      tagline: "For the children. For the families. For the island.",
      assoc: "Island Camps Association",
      location: "Saint-Barthélemy",
      contact: "Contact",
      rights: "All rights reserved.",
    },
    whyChoose: {
      kicker: "Why Island Camps",
      title: "An association designed to reassure parents",
      badge: "Registered childcare centre (ACM) with the DRAJES (Youth & Sports)",
      items: [
        { title: "Registered & safe", text: "Officially registered ACM. Qualified supervision and children's insurance included." },
        { title: "14 years of experience", text: "Born from My Little Circle (since 2012), the reference for premium childcare in Saint-Barth." },
        { title: "Small groups", text: "6 children max per session for real attention to each child." },
        { title: "Nature & creativity", text: "Days outdoors by the lagoon, between exploration and creative projects." },
      ],
    },
    philosophy: {
      kicker: "Our approach",
      title: "Learning by exploring, growing by creating",
      text: "A nature- and play-inspired approach where every child moves at their own pace.",
      steps: [
        { title: "Explore", text: "Discover Saint-Barth's nature, the lagoon and wildlife." },
        { title: "Create", text: "Arts, crafts and projects inspired by Caribbean culture." },
        { title: "Cooperate", text: "Collective projects that give meaning to learning." },
        { title: "Grow", text: "Self-confidence, independence and curiosity, while having fun." },
      ],
    },
    afterschool: {
      kicker: "Coming soon",
      badge: "Coming soon",
      title: "After-school is coming",
      text: "After school, fun and educational activities tailored to children's rhythm. Launching soon — become a member to be informed first.",
    },
    faq: {
      kicker: "FAQ",
      title: "Your questions, answered",
      items: [
        { q: "From what age?", a: "The Kids Camp welcomes children aged 6 to 14, in age-appropriate groups." },
        { q: "Do I need to be a member to book?", a: "Yes. The annual membership (€75) gives access to bookings and the member rate." },
        { q: "Is lunch provided?", a: "No, lunch is not provided. Please bring a picnic and a water bottle." },
        { q: "Where is the camp held?", a: "By the Grand Cul-de-Sac lagoon — an exceptional, safe natural setting." },
        { q: "Can I register several children?", a: "Yes, register several children and choose their slots individually." },
        { q: "Are children insured?", a: "Yes, children's insurance during activities is included in the membership." },
      ],
    },
    pricing: {
      kicker: "Pricing",
      title: "Rates designed for families",
      nonMember: "Non-member",
      member: "Member",
      memberVolume: "Member · 10 sessions & more",
      perSession: "/ session",
      badgePopular: "Most chosen",
      note: "The annual membership (€75) unlocks the member rate. Lunch not provided.",
      cta: "Become a member",
    },
    kidscamp: {
      hero: {
        kicker: "Kids Camp · Summer 2026",
        title: "A summer of adventures by the lagoon",
        subtitle: "Six weeks of exploration, creation and games at the heart of the Grand Cul-de-Sac lagoon. Every day is a new expedition.",
        cta: "Book a session",
      },
      concept: {
        title: "Much more than a day camp",
        text: "At Island Camps, every activity is a chance to learn, create and grow. In small groups of 6, our leaders spark each child's curiosity, confidence and imagination in an exceptional natural setting.",
      },
      notebook: {
        kicker: "The thread of the summer",
        title: "The Explorer's Notebook",
        text: "Each child receives their explorer's notebook: missions, nature challenges, sketches, collected treasures and weekly memories. A playful thread that gives meaning to every day.",
      },
      themes: {
        title: "Six weeks, six themes",
        items: [
          { week: "Week 1", emoji: "🧭", name: "Who am I?", desc: "Self-discovery, names, portraits and first friendships." },
          { week: "Week 2", emoji: "💛", name: "Emotions", desc: "Recognising, expressing and taming emotions through play." },
          { week: "Week 3", emoji: "🌱", name: "The living world", desc: "Nature, plants, animals and respect for life around us." },
          { week: "Week 4", emoji: "✨", name: "Imagination", desc: "Tales, invented worlds and unbridled creation." },
          { week: "Week 5", emoji: "🤝", name: "Connections", desc: "Cooperation, mutual help and big team projects." },
          { week: "Week 6", emoji: "♻️", name: "Transform", desc: "Upcycling, arts and materials to metamorphose." },
        ],
      },
      schedule: {
        title: "A typical day",
        items: [
          { time: "8:30 – 9:30", label: "Welcome & morning ritual" },
          { time: "9:30 – 10:30", label: "Main activity: exploration & play" },
          { time: "10:30", label: "Snack & quiet time" },
          { time: "11:00", label: "Creative workshop" },
          { time: "12:00", label: "Pick-up (half-day) or picnic / lunch time" },
          { time: "1:00 – 2:00", label: "Welcome & afternoon ritual" },
          { time: "2:00", label: "Activities & play resume" },
          { time: "4:00", label: "Afternoon snack" },
          { time: "4:30 – 5:00", label: "Children pick-up" },
        ],
      },
      ages: {
        title: "Age groups",
        items: [
          { range: "6–8 yrs", label: "Explorers" },
          { range: "9–11 yrs", label: "Great Adventurers" },
          { range: "12–14 yrs", label: "Pioneers" },
        ],
      },
      options: {
        title: "Half-day or full day",
        text: "Build the schedule that suits you: morning, afternoon, or full day.",
        morning: "Morning · 8:30–12:30",
        afternoon: "Afternoon · 1:00–5:00 pm",
        fullday: "Full day · 8:30 am–5:00 pm",
      },
      location: {
        title: "By the Grand Cul-de-Sac lagoon",
        text: "A protected natural setting, ideal for gentle water activities, exploration and outdoor games, safely.",
      },
      bring: {
        title: "What to bring",
        items: ["Picnic & water bottle", "Sunscreen & hat", "Swimsuit & towel", "Full change of clothes"],
      },
      safety: {
        title: "Safety & supervision",
        items: ["Registered ACM centre (DRAJES)", "Qualified leaders", "6 kids max per session", "Insurance included for members"],
      },
      gallery: { title: "The vibe in pictures" },
    },
    workshops: {
      hero: {
        kicker: "Workshops",
        title: "Wednesday & Saturday workshops",
        subtitle: "Creative and nature workshops in small groups, to explore, make and marvel all year round.",
      },
      age: "Age",
      duration: "Duration",
      spots: "Spots",
      book: "Book",
      soon: "Soon",
      regTitle: "Book your workshops",
      regSubtitle: "Pick your Wednesday & Saturday afternoon sessions. Same rate as sessions: €50 (non-member) · €45 (member) · €40 (from 10 sessions).",
      specialTitle: "Special events",
      specialSubtitle: "Our themed workshops and one-off events.",
    },
    booking: {
      title: "Book your sessions",
      subtitle: "School year 2026–2027 · Morning & Afternoon · 6 kids max per session",
      parent: "Your details",
      parentName: "Parent name",
      email: "Email",
      phone: "Phone",
      children: "Children",
      childName: "Child's first name",
      addChild: "Add a child",
      selectFor: "Schedule for",
      morning: "Morning",
      afternoon: "Afternoon",
      full: "Full",
      remaining: "spots",
      summary: "Summary",
      totalSessions: "Selected sessions",
      unitPrice: "Unit price",
      discountActive: "Pack rate applied (≥ 10 sessions for one child) 🎉",
      discountHint: "10 sessions for the same child → €40 / session for that child.",
      lunch: "Lunch not provided — bring a picnic 🥪",
      total: "Total",
      pay: "Pay by card",
      paying: "Redirecting to payment…",
      emptyCart: "Select at least one session to continue.",
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      weekend: "Closed on weekends",
      success: "Payment confirmed!",
      successText: "Thank you, your booking is confirmed. A summary is waiting below.",
      processing: "Verifying payment…",
      failed: "The payment did not go through. You can try again.",
      paymentPending: "Payment is being processed",
      paymentPendingText: "Your payment is being processed. You will receive a confirmation email. You can also check in your account area.",
      viewMyAccount: "View my account",
      backToBooking: "New booking",
      memberBadge: "Member · member rate",
      notMemberBadge: "Non-member · standard rate",
      memberNudge: "Become a member (€75/yr) for the member rate from €45/session.",
      becomeMember: "Become a member",
      fullDay: "Full day",
      checking: "Checking…",
      emergencyTitle: "Emergency contact",
      emergencyName: "Emergency contact name",
      emergencyPhone: "Emergency phone",
      allergies: "Allergies / medical info",
      allergiesPlaceholder: "e.g. peanuts, asthma… (optional)",
      requiredFields: "Please enter your name and a valid email.",
      payError: "Something went wrong during payment. Please try again.",
      childFirstName: "Child's first name",
      childLastName: "Child's last name",
      dob: "Date of birth",
      groupHint: "Group (indicative, by age)",
      groupUnknown: "Enter the date of birth",
      outOfRange: "Outside 3–14 age range",
      yearsShort: "yrs",
      noDates: "No dates available for this period yet.",
      ageGroups: [
        { min: 3, max: 5, name: "Little Sailors" },
        { min: 6, max: 8, name: "Explorers" },
        { min: 9, max: 11, name: "Great Adventurers" },
        { min: 12, max: 14, name: "Pioneers" },
      ],
      consentsTitle: "Authorizations",
      consentsIntro: "Please provide the authorizations for your child/children (optional).",
      authorizedPickup: "People authorized to pick up the child",
      authorizedPickupPlaceholder: "Name(s) and relationship (optional)",
      consentImage: "I allow photos/videos to be taken and shared (image rights).",
      consentOutdoor: "I allow participation in outdoor activities and outings.",
      consentSwim: "I allow my child to swim under supervision.",
      consentTransport: "I allow my child to be transported/driven in an emergency (vehicle / rescue).",
      consentRules: "I acknowledge and accept the association's internal rules.",
      residentConfirm: "I confirm that the child lives in Saint-Barthélemy.",
      residentRequired: "Activities are reserved for children living in Saint-Barthélemy. Please tick the confirmation.",
      comingSoon: "Coming soon",
      underAgeNotice: "Registration is reserved for children who have fully turned 6 on the session date. Coming soon for younger children.",
      underAgeError: "Some selected sessions are for a child under 6. Please remove them to continue.",
      consentYes: "Yes",
      consentNo: "No",
      rulesRequired: "Please accept the internal rules to continue.",
    },
    carnet: {
      kicker: "The logbook",
      title: "This summer's logbook",
      text: "A few stolen moments from our adventures: budding pirates, mermaids, little investigations and nature's treasures.",
      cta: "Book your spot",
    },
    member: {
      title: "Become a member",
      subtitle: "Annual membership of the Island Camps association — €75 / year (€50 membership + €25 child all-risk insurance)",
      info: "Your details",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      summary: "Summary",
      item: "Annual membership",
      total: "Total",
      pay: "Join · Pay €75",
      feeMembership: "Membership",
      feeInsurance: "All-risk insurance (child)",
      paying: "Redirecting to payment…",
      includesTitle: "Included in membership",
      success: "Welcome to Island Camps!",
      successText: "Your membership is confirmed. You can now book the association's activities.",
      processing: "Verifying payment…",
      failed: "The payment did not go through. You can try again.",
      paymentPending: "Payment is being processed",
      paymentPendingText: "Your payment is being processed. You will receive a confirmation email. You can also check in your account area.",
      viewMyAccount: "View my account",
      goBook: "Book a session",
      requiredFields: "Please enter your name and a valid email.",
      payError: "Something went wrong during payment. Please try again.",
      address: "Address",
      childrenTitle: "Child(ren)",
      addChild: "Add a child",
      childFirstName: "Child's first name",
      childLastName: "Child's last name",
      dob: "Date of birth",
      groupHint: "Group (indicative, by age)",
      groupUnknown: "Enter the date of birth",
      yearsShort: "yrs",
      outOfRange: "Outside 6–14 age range",
      medical: "Medical information",
      medicalPlaceholder: "Allergies, ongoing treatment, family doctor…",
      interests: "What they love in life",
      interestsPlaceholder: "Passions, favourite activities…",
      emergencyTitle: "Emergency contact",
      emergencyName: "Emergency contact name",
      emergencyPhone: "Emergency phone",
      consentsTitle: "Authorizations",
      consentsIntro: "Authorizations for your child/children (optional).",
      consentImage: "I allow photos/videos to be taken and published (image rights).",
      consentOutdoor: "I allow participation in outdoor activities and outings.",
      consentSwim: "I allow my child to swim under supervision.",
      consentTransport: "I allow my child to be transported/driven in an emergency (vehicle / rescue).",
      consentRules: "I acknowledge and accept the internal rules.",
      consentsRequired: "Please accept all mandatory consents to continue.",
    },
  },
};
